/**
 * Collection shop grid: client-side type filter, sort, pagination.
 * Loads products via /collections/{handle}/products.json (same-origin).
 */
(function () {
  'use strict';

  function formatMoneyFromDollars(dollarStr) {
    var cents = Math.round(parseFloat(dollarStr || '0') * 100);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function escapeHtml(s) {
    if (s == null || s === '') return '';
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function imgSrcAtWidth(src, width) {
    if (!src) return '';
    var sep = src.indexOf('?') >= 0 ? '&' : '?';
    return src + sep + 'width=' + width;
  }

  function getColorOptionIndex(options) {
    if (!options || !options.length) return -1;
    for (var i = 0; i < options.length; i++) {
      var n = (options[i].name || '').toLowerCase();
      if (n === 'color' || n === 'colour') return i;
    }
    return -1;
  }

  function variantOptionMatch(v, colorIdx, value) {
    if (colorIdx === 0) return v.option1 === value;
    if (colorIdx === 1) return v.option2 === value;
    if (colorIdx === 2) return v.option3 === value;
    return false;
  }

  function findVariantForColor(product, colorIdx, value) {
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (variantOptionMatch(variants[i], colorIdx, value)) return variants[i];
    }
    return null;
  }

  function swatchImageUrl(variant) {
    if (!variant || !variant.featured_image) return '';
    var att = variant.featured_image;
    if (typeof att === 'string') return att;
    if (typeof att === 'object' && att.src) return att.src;
    return '';
  }

  function buildSwatchesHtml(product, productUrl) {
    var options = product.options || [];
    var colorIdx = getColorOptionIndex(options);
    if (colorIdx < 0) return '';
    var opt = options[colorIdx];
    var values = opt.values || [];
    if (values.length <= 1) return '';

    var html =
      '<div class="product-card__swatches" role="group" aria-label="Color">';
    for (var vi = 0; vi < values.length; vi++) {
      var value = values[vi];
      var swatchV = findVariantForColor(product, colorIdx, value);
      if (!swatchV) continue;
      var swImg = swatchImageUrl(swatchV);
      var hasImg = !!swImg;
      var dotClass = hasImg ? '' : ' product-card__swatch--dot';
      var styleAttr = '';
      if (!hasImg) {
        var fakeColor = String(value || '')
          .toLowerCase()
          .replace(/\s+/g, '')
          .replace(/-/g, '');
        styleAttr = ' style="background-color: ' + escapeHtml(fakeColor) + ';"';
      }
      html +=
        '<a href="' +
        escapeHtml(productUrl + '?variant=' + swatchV.id) +
        '" class="product-card__swatch' +
        dotClass +
        '"' +
        styleAttr +
        ' title="' +
        escapeHtml(value) +
        '" aria-label="' +
        escapeHtml(value) +
        '">';
      if (hasImg) {
        html +=
          '<img src="' +
          escapeHtml(imgSrcAtWidth(swImg, 88)) +
          '" alt="' +
          escapeHtml(value) +
          '" width="22" height="22" loading="lazy" decoding="async">';
      }
      html += '</a>';
    }
    html += '</div>';
    return html;
  }

  function buildCardHtml(product, money) {
    var handle = product.handle || '';
    var productUrl = '/products/' + encodeURIComponent(handle);
    var images = product.images || [];
    var primary = images[0];
    var secondary = images.length > 1 ? images[1] : null;
    if (primary && secondary && primary.id === secondary.id) secondary = null;

    var primarySrc = primary ? imgSrcAtWidth(primary.src, 600) : '';
    var secondarySrc = secondary ? imgSrcAtWidth(secondary.src, 600) : '';
    var hoverClass =
      secondarySrc ? ' product-card__image-wrap--hoverable' : '';

    var title = product.title || '';
    var price = product.price;
    if (price == null && product.variants && product.variants[0]) {
      price = product.variants[0].price;
    }
    var priceStr = money(price != null ? String(price) : '0');

    var imgBlock = '';
    if (primarySrc) {
      imgBlock +=
        '<img class="product-card__image product-card__image--primary" src="' +
        escapeHtml(primarySrc) +
        '" alt="' +
        escapeHtml(primary.alt || title) +
        '" width="600" height="600" loading="lazy" decoding="async">';
      if (secondarySrc) {
        imgBlock +=
          '<img class="product-card__image product-card__image--secondary" src="' +
          escapeHtml(secondarySrc) +
          '" alt="" width="600" height="600" loading="lazy" decoding="async" aria-hidden="true">';
      }
    } else {
      imgBlock =
        '<span class="product-card__image product-card__image--primary"></span>';
    }

    var swatches = buildSwatchesHtml(product, productUrl);

    return (
      '<li data-product-type="' +
      escapeHtml(productType(product)) +
      '">' +
      '<div class="product-card">' +
      '<a class="product-card__image-link" href="' +
      escapeHtml(productUrl) +
      '">' +
      '<div class="product-card__image-wrap' +
      hoverClass +
      '">' +
      imgBlock +
      '</div></a>' +
      '<div class="product-card__meta">' +
      '<a href="' +
      escapeHtml(productUrl) +
      '" class="product-card__meta-link">' +
      '<h2 class="product-card__title">' +
      escapeHtml(title) +
      '</h2>' +
      '<p class="product-card__price">' +
      escapeHtml(priceStr) +
      '</p></a></div>' +
      swatches +
      '</div></li>'
    );
  }

  function sortProducts(list, key) {
    var out = list.slice();
    if (key === 'manual') return out;

    function firstPrice(p) {
      var v = (p.variants && p.variants[0]) || {};
      return parseFloat(v.price || p.price || '0');
    }

    if (key === 'price-ascending') {
      out.sort(function (a, b) {
        return firstPrice(a) - firstPrice(b);
      });
    } else if (key === 'price-descending') {
      out.sort(function (a, b) {
        return firstPrice(b) - firstPrice(a);
      });
    } else if (key === 'title-ascending') {
      out.sort(function (a, b) {
        return String(a.title || '').localeCompare(String(b.title || ''));
      });
    } else if (key === 'title-descending') {
      out.sort(function (a, b) {
        return String(b.title || '').localeCompare(String(a.title || ''));
      });
    }
    return out;
  }

  function productType(p) {
    return String(p.product_type || p.type || '').trim();
  }

  function filterByType(list, type) {
    if (!type) return list.slice();
    var t = String(type).trim();
    return list.filter(function (p) {
      return productType(p) === t;
    });
  }

  function uniqueTypes(products) {
    var set = {};
    for (var i = 0; i < products.length; i++) {
      var t = productType(products[i]);
      if (t) set[t] = true;
    }
    return Object.keys(set).sort(function (a, b) {
      return a.localeCompare(b);
    });
  }

  function fetchAll(collectionHandle) {
    var limit = 250;
    var page = 1;
    var all = [];

    function next() {
      return fetch(
        '/collections/' +
          encodeURIComponent(collectionHandle) +
          '/products.json?limit=' +
          limit +
          '&page=' +
          page
      )
        .then(function (r) {
          if (!r.ok) throw new Error('products.json failed');
          return r.json();
        })
        .then(function (data) {
          var batch = (data && data.products) || [];
          if (!batch.length) return all;
          for (var i = 0; i < batch.length; i++) all.push(batch[i]);
          if (batch.length < limit) return all;
          page += 1;
          return next();
        });
    }

    return next();
  }

  function readState(url) {
    var params = new URLSearchParams(url.search || '');
    var sort =
      params.get('ns_sort') ||
      params.get('sort_by') ||
      'manual';
    var allowed = {
      manual: true,
      'price-ascending': true,
      'price-descending': true,
      'title-ascending': true,
      'title-descending': true
    };
    if (!allowed[sort]) sort = 'manual';

    var type =
      params.get('ns_type') ||
      params.get('filter.p.product_type') ||
      '';
    var pg = parseInt(params.get('ns_page') || '1', 10);
    if (isNaN(pg) || pg < 1) pg = 1;
    return { sort: sort, type: type, page: pg };
  }

  function pushUrl(section, state, page) {
    var url = new URL(window.location.href);
    if (state.type) url.searchParams.set('ns_type', state.type);
    else url.searchParams.delete('ns_type');

    url.searchParams.set('ns_sort', state.sort);
    if (page > 1) url.searchParams.set('ns_page', String(page));
    else url.searchParams.delete('ns_page');

    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  function initSection(section) {
    var handle = section.getAttribute('data-collection-handle');
    var perPage = parseInt(section.getAttribute('data-products-per-page'), 10) || 9;
    var allCount = parseInt(section.getAttribute('data-all-products-count'), 10) || 0;
    var loadingEl = section.querySelector('[data-collection-loading]');
    var listEl = section.querySelector('[data-collection-products]');
    var emptyEl = section.querySelector('[data-collection-empty]');
    var pagEl = section.querySelector('[data-collection-pagination]');
    var statusEl = section.querySelector('[data-collection-status]');
    var filterMenu = section.querySelector('[data-collection-filter-menu]');
    var filterTriggerLabel = section.querySelector('[data-collection-filter-label]');
    var sortMenus = section.querySelectorAll('[data-collection-sort-menu]');
    var sortTriggerLabels = section.querySelectorAll('[data-collection-sort-label]');

    if (!handle || !listEl) return;

    var money = formatMoneyFromDollars;
    var allProducts = [];

    function announce(message) {
      if (statusEl) statusEl.textContent = message;
    }

    function setDropdownOpen(dd, open) {
      if (!dd) return;
      dd.classList.toggle('is-open', open);
      var trigger = dd.querySelector('[data-dropdown-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeDropdown(dd, returnFocus) {
      if (!dd) return;
      setDropdownOpen(dd, false);
      if (returnFocus) {
        var trigger = dd.querySelector('[data-dropdown-trigger]');
        if (trigger) trigger.focus();
      }
    }

    function closeAllDropdowns(except) {
      section.querySelectorAll('[data-dropdown]').forEach(function (d) {
        if (d !== except) setDropdownOpen(d, false);
      });
    }

    function focusMenuOption(dd, direction) {
      if (!dd) return;
      var opts = Array.prototype.slice.call(dd.querySelectorAll('.ns-dropdown__option'));
      if (!opts.length) return;
      var current = opts.indexOf(document.activeElement);
      if (current < 0) {
        var selected = opts.filter(function (opt) {
          return opt.classList.contains('is-selected');
        })[0];
        current = selected ? opts.indexOf(selected) : 0;
      } else {
        current = (current + direction + opts.length) % opts.length;
      }
      opts[current].focus();
    }

    function bindDropdownKeyboard(dd) {
      var trigger = dd.querySelector('[data-dropdown-trigger]');
      if (!trigger) return;
      trigger.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Escape') return;
        e.preventDefault();
        if (e.key === 'Escape') {
          closeDropdown(dd, true);
          return;
        }
        closeAllDropdowns(dd);
        setDropdownOpen(dd, true);
        focusMenuOption(dd, e.key === 'ArrowUp' ? -1 : 1);
      });
      dd.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          closeDropdown(dd, true);
          return;
        }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          focusMenuOption(dd, e.key === 'ArrowUp' ? -1 : 1);
        }
      });
    }

    function sortLabel(key) {
      switch (key) {
        case 'price-ascending':
          return 'Low to high';
        case 'price-descending':
          return 'High to low';
        case 'title-ascending':
          return 'A–Z';
        case 'title-descending':
          return 'Z–A';
        default:
          return 'Featured';
      }
    }

    function renderPagination(totalItems, currentPage) {
      if (!pagEl) return;
      var totalPages = Math.max(1, Math.ceil(totalItems / perPage));
      if (totalPages <= 1) {
        pagEl.hidden = true;
        pagEl.innerHTML = '';
        return;
      }
      pagEl.hidden = false;

      var svgPrev =
        '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<path d="M15 6L9 12L15 18" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var svgNext =
        '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      var prevHtml =
        currentPage > 1
          ? '<button type="button" class="collection-grid__page-arrow collection-grid__page-arrow--prev" data-collection-page="' +
            (currentPage - 1) +
            '" aria-label="Previous page">' +
            svgPrev +
            '</button>'
          : '<span class="collection-grid__page-arrow collection-grid__page-arrow--prev collection-grid__page-arrow--disabled" aria-hidden="true">' +
            svgPrev +
            '</span>';

      var nextHtml =
        currentPage < totalPages
          ? '<button type="button" class="collection-grid__page-arrow collection-grid__page-arrow--next" data-collection-page="' +
            (currentPage + 1) +
            '" aria-label="Next page">' +
            svgNext +
            '</button>'
          : '<span class="collection-grid__page-arrow collection-grid__page-arrow--next collection-grid__page-arrow--disabled" aria-hidden="true">' +
            svgNext +
            '</span>';

      var html =
        '<div class="collection-grid__pagination-inner">' +
        prevHtml +
        '<ul class="collection-grid__page-list" role="list">';
      for (var i = 1; i <= totalPages; i++) {
        if (i === currentPage) {
          html +=
            '<li><span class="collection-grid__page-num collection-grid__page-num--current" aria-current="page">' +
            i +
            '</span></li>';
        } else {
          html +=
            '<li><button type="button" class="collection-grid__page-num" data-collection-page="' +
            i +
            '">' +
            i +
            '</button></li>';
        }
      }
      html += '</ul>' + nextHtml + '</div>';
      pagEl.innerHTML = html;
      pagEl.setAttribute('aria-label', 'Pagination');

      pagEl.querySelectorAll('[data-collection-page]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var np = parseInt(btn.getAttribute('data-collection-page'), 10);
          if (isNaN(np)) return;
          var nextSt = readState(new URL(window.location.href));
          nextSt.page = np;
          pushUrl(
            section,
            { type: nextSt.type, sort: nextSt.sort },
            nextSt.page
          );
          renderView(nextSt);
        });
      });
    }

    function renderView(st) {
      var curPage = st.page || 1;
      var filtered = filterByType(allProducts, st.type);
      var sorted = sortProducts(filtered, st.sort);
      var total = sorted.length;

      if (filterTriggerLabel) {
        filterTriggerLabel.textContent = st.type || 'All';
      }
      sortTriggerLabels.forEach(function (el) {
        el.textContent = 'Sort by: ' + sortLabel(st.sort);
      });

      if (total === 0) {
        listEl.innerHTML = '';
        listEl.hidden = true;
        if (emptyEl) emptyEl.hidden = false;
        if (pagEl) {
          pagEl.hidden = true;
          pagEl.innerHTML = '';
        }
        syncFilterMenuSelection(st);
        syncSortMenuSelection(st);
        announce('No products match this filter.');
        return;
      }

      if (emptyEl) emptyEl.hidden = true;
      listEl.hidden = false;

      var totalPages = Math.max(1, Math.ceil(total / perPage));
      if (curPage > totalPages) curPage = totalPages;
      if (curPage < 1) curPage = 1;

      var start = (curPage - 1) * perPage;
      var slice = sorted.slice(start, start + perPage);

      var html = '';
      for (var i = 0; i < slice.length; i++) {
        html += buildCardHtml(slice[i], money);
      }
      listEl.innerHTML = html;

      renderPagination(total, curPage);
      syncFilterMenuSelection(st);
      syncSortMenuSelection(st);
      announce(
        'Showing ' +
          slice.length +
          ' of ' +
          total +
          ' ' +
          (total === 1 ? 'product' : 'products') +
          '.'
      );
    }

    function parseTypeFilterAttr(raw) {
      if (raw === null || raw === '') return '';
      try {
        return decodeURIComponent(raw);
      } catch (e) {
        return raw;
      }
    }

    function syncFilterMenuSelection(st) {
      if (!filterMenu) return;
      var active = String(st.type || '').trim();
      filterMenu
        .querySelectorAll('[data-collection-type-filter]')
        .forEach(function (btn) {
          var val = parseTypeFilterAttr(
            btn.getAttribute('data-collection-type-filter')
          );
          var btnType = String(val).trim();
          var isAllBtn = btnType === '';
          var selected = isAllBtn ? active === '' : active === btnType;
          btn.classList.toggle('is-selected', selected);
          btn.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
    }

    function syncSortMenuSelection(st) {
      sortMenus.forEach(function (menu) {
        menu.querySelectorAll('[data-collection-sort]').forEach(function (btn) {
          var key = btn.getAttribute('data-collection-sort') || 'manual';
          btn.classList.toggle('is-selected', key === st.sort);
          btn.setAttribute('aria-checked', key === st.sort ? 'true' : 'false');
        });
      });
    }

    function buildFilterMenu(types, currentType) {
      if (!filterMenu) return;
      var html =
        '<button type="button" class="ns-dropdown__option' +
        (!currentType ? ' is-selected' : '') +
        '" role="menuitemradio" aria-checked="' +
        (!currentType ? 'true' : 'false') +
        '" data-collection-type-filter="">All</button>';
      for (var i = 0; i < types.length; i++) {
        var t = types[i];
        html +=
          '<button type="button" class="ns-dropdown__option' +
          (currentType === t ? ' is-selected' : '') +
          '" role="menuitemradio" aria-checked="' +
          (currentType === t ? 'true' : 'false') +
          '" data-collection-type-filter="' +
          encodeURIComponent(t) +
          '">' +
          escapeHtml(t) +
          '</button>';
      }
      filterMenu.innerHTML = html;
      filterMenu.querySelectorAll('[data-collection-type-filter]').forEach(
        function (btn) {
          btn.addEventListener('click', function () {
            var raw = btn.getAttribute('data-collection-type-filter');
            var val = '';
            if (raw !== null && raw !== '') {
              try {
                val = decodeURIComponent(raw);
              } catch (e) {
                val = raw;
              }
            }
            var base = readState(new URL(window.location.href));
            var nextSt = {
              type: val,
              sort: base.sort,
              page: 1
            };
            pushUrl(section, { type: nextSt.type, sort: nextSt.sort }, 1);
            renderView(nextSt);
            closeDropdown(btn.closest('[data-dropdown]'), true);
          });
        }
      );
    }

    function buildSortMenu(currentSort) {
      if (!sortMenus.length) return;
      var opts = [
        { key: 'manual', label: 'Featured' },
        { key: 'price-ascending', label: 'Low to high' },
        { key: 'price-descending', label: 'High to low' },
        { key: 'title-ascending', label: 'A–Z' },
        { key: 'title-descending', label: 'Z–A' }
      ];
      var html = '';
      for (var i = 0; i < opts.length; i++) {
        var o = opts[i];
        html +=
          '<button type="button" class="ns-dropdown__option' +
          (currentSort === o.key ? ' is-selected' : '') +
          '" role="menuitemradio" aria-checked="' +
          (currentSort === o.key ? 'true' : 'false') +
          '" data-collection-sort="' +
          o.key +
          '">' +
          o.label +
          '</button>';
      }
      sortMenus.forEach(function (sortMenu) {
        sortMenu.innerHTML = html;
        sortMenu.querySelectorAll('[data-collection-sort]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var key = btn.getAttribute('data-collection-sort') || 'manual';
            var base = readState(new URL(window.location.href));
            var nextSt = {
              type: base.type,
              sort: key,
              page: 1
            };
            pushUrl(section, { type: nextSt.type, sort: nextSt.sort }, 1);
            renderView(nextSt);
            closeDropdown(btn.closest('[data-dropdown]'), true);
          });
        });
      });
    }

    fetchAll(handle)
      .then(function (products) {
        allProducts = products;
        if (loadingEl) loadingEl.hidden = true;

        var types = uniqueTypes(products);
        var st = readState(new URL(window.location.href));
        buildFilterMenu(types, st.type);
        buildSortMenu(st.sort);
        renderView(st);
      })
      .catch(function () {
        if (loadingEl) loadingEl.hidden = true;
        announce('Could not load products. Please refresh and try again.');
        if (emptyEl) {
          emptyEl.hidden = false;
          emptyEl.textContent =
            'Could not load products. Please refresh and try again.';
        }
      });

    // Dropdown toggles (filter + sort)
    section.querySelectorAll('[data-dropdown]').forEach(function (dd) {
      var trigger = dd.querySelector('[data-dropdown-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var wasOpen = dd.classList.contains('is-open');
        closeAllDropdowns(dd);
        setDropdownOpen(dd, !wasOpen);
      });
      bindDropdownKeyboard(dd);
    });
    document.addEventListener('click', function () {
      closeAllDropdowns();
    });
  }

  function boot() {
    document.querySelectorAll('[data-collection-grid]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
